import { createContext } from 'react';
import { ToastCreator } from './useToastCreator';

export interface ToastContextValue {
  toast?: ToastCreator;
}

export const ToastContext = createContext<ToastContextValue>({});
